module.exports = __webpack_public_path__ + "static/dj-snake-818d93fe57e56900feadd69d75e50a7d.webp";